export default {"src":"/_next/static/media/icon-ups.ead00e53.svg","height":20,"width":19,"blurWidth":0,"blurHeight":0};